import React, { useState, useEffect, Fragment } from 'react';
import services from '../services';
import { validateProperty, validate } from "../../Common"
import { CollectioncategoryCollectiontypeEditSchema } from '../CollectioncategoryTypeSchema';
import { PageHeader } from '../../../Common';
import MessageModal from '../../../UI/Modal/MessageModal';
import Joi from '@hapi/joi'
import groupService from '../../Group/services';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormHelperText from '@material-ui/core/FormHelperText';
import collectionCategoryService from '../../CollectionCategory/services';
import TextField from '@material-ui/core/TextField';
import authService from '../../Common/services';
import { LoadingSpinerComponent } from '../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import tokenService from '../../../Common/tokenDecoder';
import { MultiSelect } from "../../../Common/multiSelect";

const screenCode = 'COLLECTIONCATEGORYTYPEMAPPING';

export function CollectioncategoryTypeMappingAddEdit(props) {

    const { data, edit } = props.location;
    const [title, setTitle] = useState("Add Collection Type to Collection Category");
    const [buttonText, setButtonText] = useState("Add");
    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [product, setProduct] = useState([]);
    const [collectionCatagory, setCollectionCatagory] = useState([]);
    const [collectionType, setCollectionType] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [collectioncategoryTypeMapping, setCollectioncategoryTypeMapping] = useState({
        groupID: '0',
        operationEntityID: '0',
        productID: '0',
        collectionCategoryID: '0',
        isActive: true,
        isDefault: false
    });

    const [errors, setErrors] = useState({});
    const [messageModel, setMessageModel] = useState({
        hidden: true,
        type: "Success",
        disciption: "completed successfuly."
    });

    const getOptionLabel = option => `${option.label}`;
    const getOptionDisabled = option => option.value === "foo";
    const handleToggleOption = selectedOptions =>
        setSelectedOptions(selectedOptions);
    const handleClearOptions = () => setSelectedOptions([]);
    const handleSelectAll = isSelected => {
        if (isSelected) {
            setSelectedOptions(collectionType);
        } else {
            handleClearOptions();
        }
    };

    const schema = Joi.object(CollectioncategoryCollectiontypeEditSchema).options({ allowUnknown: true });

    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        trackPromise(
            getOperationEntitiesForDropdown()
        )
    }, [collectioncategoryTypeMapping.groupID]);

    useEffect(() => {
        trackPromise(
            getProductsForDropDown()
        )
    }, [collectioncategoryTypeMapping.operationEntityID]);

    useEffect(() => {
        trackPromise(
            getCollectionCategoryForDropdown()
        )
    }, [collectioncategoryTypeMapping.productID]);

    useEffect(() => {
        trackPromise(
            getAvailableCollectionTypes()
        )
    }, [collectioncategoryTypeMapping.collectionCategoryID]);

    useEffect(() => {
        checkCollectionTypesErrors()
    }, [selectedOptions]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);

        var isAuthorized = permissions.find(p => p.permissionCode == 'ADDEDITCOLLECTIONCATEGORYTYPE');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }

        if (data && edit) {
            setTitle("Edit Collection Type to Collection Category");
            fillOperationEntityProductEditdata(data);
            setButtonText("Update");
        } else {
            setTitle("Add Collection Type to Collection Category");

            var token = tokenService.getUserDetailsFromToken();
            setCollectioncategoryTypeMapping({
                ...collectioncategoryTypeMapping,
                groupID: token.groupID,
                operationEntityID: token.operationEntityID
            });
        }

        trackPromise(
            getGroupsForDropdown()
        )
    }

    async function getGroupsForDropdown() {
        const groups = await groupService.getGroupsForDropdown();
        setGroups(groups);
    }

    async function getOperationEntitiesForDropdown() {
        const opEntities = await services.getAllOperationEntitiesForDropDown(collectioncategoryTypeMapping.groupID);
        setOperationEntity(opEntities);
    }

    async function getCollectionCategoryForDropdown() {
        const collectionCatagories = await collectionCategoryService.GetCollectionCategoryByOperationEntityID(collectioncategoryTypeMapping.operationEntityID);
        setCollectionCatagory(collectionCatagories);
    }

    async function getProductsForDropDown() {
        var products = [];
        if (edit && data) {
            products = await services.getProducts();
        } else {
            products = await services.getAvialableProducts(collectioncategoryTypeMapping.operationEntityID);
        }
        setProduct(products);
    }

    function checkCollectionTypesErrors() {
        const error = { ...errors };

        if (selectedOptions.length <= 0) {
            error["collectionTypeID"] = "Select at least one collection type.";
        } else {
            delete error["collectionTypeID"]
        }

        setErrors(error);
    }

    async function fillOperationEntityProductEditdata(data) {
        const selectedOperationEntity = await services.getGroupByCollectionCatagoryID(data.collectionCategoryID.toString());
        var collectionTypeArray = [];

        collectionTypeArray.push({ label: data.collectionTypeName, value:  data.collectionTypeMasterID });

        if (data.isActive === true) {
            setButtonText("Deactivate");
        }
        else {
            setButtonText("Activate");
        }
        if (selectedOperationEntity) {
            setSelectedOptions(collectionTypeArray);
            setCollectioncategoryTypeMapping({
                ...collectioncategoryTypeMapping,
                groupID: selectedOperationEntity[0].groupID.toString(),
                operationEntityID: selectedOperationEntity[0].operationEntityID.toString(),
                productID: selectedOperationEntity[0].productID.toString(),
                collectionCategoryID: data.collectionCategoryID.toString(),
                isActive: data.isActive,
                isDefault: data.isDefault
            });
        }
    }

    function handleChange(e) {
        const target = e.target;

        const value = (target.name === 'isActive' || target.name === "isDefault") ? target.checked : target.value

        if (target.name === "collectionCategoryCode") {
            if (target.value.length === 3) return false
        }

        const error = { ...errors };
        const errorMessage = validateProperty(target, CollectioncategoryCollectiontypeEditSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setCollectioncategoryTypeMapping({
            ...collectioncategoryTypeMapping,
            [e.target.name]: value
        });
        setErrors(error);
    }

    function handleGroupChange(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, CollectioncategoryCollectiontypeEditSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];
        setCollectioncategoryTypeMapping({
            ...collectioncategoryTypeMapping,
            groupID: target.value,
            operationEntityID: '0',
            productID: '0',
            collectionCategoryID: '0'
        });
        setSelectedOptions([]);
        setErrors(error);
    }
    
    function handleOperationEntityChange(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, CollectioncategoryCollectiontypeEditSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];
        setCollectioncategoryTypeMapping({
            ...collectioncategoryTypeMapping,
            operationEntityID: target.value,
            productID: '0',
            collectionCategoryID: '0'
        });
        setSelectedOptions([]);
        setErrors(error);
    }

    function handleProductChange(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, CollectioncategoryCollectiontypeEditSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];
        setCollectioncategoryTypeMapping({
            ...collectioncategoryTypeMapping,
            productID: target.value,
            collectionCategoryID: '0'
        });
        setSelectedOptions([]);
        setErrors(error);
    }

    function handleCollectioCategoryChange(target) {
        const error = { ...errors };
        const errorMessage = validateProperty(target, CollectioncategoryCollectiontypeEditSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];
        setCollectioncategoryTypeMapping({
            ...collectioncategoryTypeMapping,
            collectionCategoryID: target.value
        });
        setSelectedOptions([]);
        setErrors(error);
    }

    async function handleSave(e) {
        e.preventDefault();

        const errorMessages = validate(schema, collectioncategoryTypeMapping);
        var checkErrors = (errorMessages !== null || selectedOptions.length <= 0);
        if (checkErrors) return;

        if (!edit) {
            var result = await services.AddOperationentityCollectionCatagory(collectioncategoryTypeMapping, selectedOptions);
            setMessageModel({ ...messageModel, hidden: false, type: result.statusCode, disciption: result.message });
            afterSuccessfulyChanged(result.statusCode);
        } else if (edit) {
            var result = await services.EditOperationentityCollectionCatagory(parseInt(data.collectionTypeID));
            setMessageModel({ ...messageModel, hidden: false, type: result.statusCode, disciption: result.message });
            afterSuccessfulyChanged(result.statusCode);
        }
    }

    async function handleIsDefaultChange(e) {
        trackPromise(
            checkDefaultColletionTypeAvailability(e.target.checked)
        )
    }

    function afterSuccessfulyChanged(response) {
        if (response === "Success") {
            clearState()
            setTimeout(() => {
                props.history.push({ pathname: '/collectioncategorytypemapping' })
            }, 1500);
        }
    }

    function clearState() {
        setCollectioncategoryTypeMapping({
            ...collectioncategoryTypeMapping,
            groupID: '0',
            operationEntityID: '0',
            productID: '0',
            collectionCategoryName: '0',
            isActive: true,
            isDefault: false
        });
    }

    function modalDismissHandler() {
        setMessageModel({ ...messageModel, hidden: true });
    }

    function onCancelClick() {
        setErrors({});
        clearState();
    }

    function generateDropDownMenu(data) {
        let items = [];
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items;
    }

    async function checkDefaultColletionTypeAvailability(checked) {
        const error = { ...errors };

        if (!(collectioncategoryTypeMapping.collectionCategoryID > 0)) {
            error["isDefault"] = "Collection Category is not selected."
            setErrors(error);
            return;
        }

        if (checked) {

            var result = await services.checkDefaultColletionTypeAvailability(collectioncategoryTypeMapping.collectionCategoryID);

            if (result.data) {
                error["isDefault"] = "Default collection type exisits."
                setErrors(error);
                return;
            }

        }

        delete error["isDefault"];
        setErrors(error);

        setCollectioncategoryTypeMapping({
            ...collectioncategoryTypeMapping,
            isDefault: checked
        });
    }

    async function getAvailableCollectionTypes() {
        const collectionTypes = await services.getCollectionType(collectioncategoryTypeMapping);
        setCollectionType(collectionTypes);
    }

    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="col-md-12">
                    <div className="card">
                        <div className="card-body">
                            <div className="row">
                                <PageHeader
                                    title={title}
                                    isButtonEnable={true}
                                    path="/collectioncategorytypemapping"
                                    buttonText="Back to listing"
                                />
                            </div>
                            <hr />

                            <form onSubmit={(e) => handleSave(e)} disabled={false}>
                                <div className="form-group row">
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="groupID">Group *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="groupID"
                                            id="groupID"
                                            name="groupID"
                                            disabled={(edit && data) ? true : false}
                                            value={collectioncategoryTypeMapping.groupID}
                                            onChange={(e) => handleGroupChange(e.target)}>
                                            <MenuItem value="0">--Select Group--</MenuItem>
                                            {generateDropDownMenu(groups)}
                                        </Select>
                                        {errors["groupID"] && <FormHelperText error>{errors["groupID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pb-1">
                                        <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="operationEntityID"
                                            id="operationEntityID"
                                            name="operationEntityID"
                                            disabled={(edit && data) ? true : false}
                                            value={collectioncategoryTypeMapping.operationEntityID}
                                            onChange={(e) => handleOperationEntityChange(e.target)}>
                                            <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                            {generateDropDownMenu(operationEntity)}
                                        </Select>
                                        {errors["operationEntityID"] && <FormHelperText error>{errors["operationEntityID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md">
                                        <InputLabel shrink id="productID">Product *</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="productID"
                                            id="productID"
                                            name="productID"
                                            disabled={(edit && data) ? true : false}
                                            value={collectioncategoryTypeMapping.productID}
                                            onChange={(e) => handleProductChange(e.target)}>
                                            <MenuItem value="0">--Select Product--</MenuItem>
                                            {generateDropDownMenu(product)}
                                        </Select>
                                        {errors["productID"] && <FormHelperText error>{errors["productID"]}</FormHelperText>}
                                    </div>
                                </div>

                                <div className="form-group row">
                                    <div className="col-md">
                                        <InputLabel shrink id="collectionCategoryID">Collection Category*</InputLabel>
                                        <Select
                                            fullWidth
                                            labelId="collectionCategoryID"
                                            id="collectionCategoryID"
                                            name="collectionCategoryID"
                                            disabled={(edit && data) ? true : false}
                                            value={collectioncategoryTypeMapping.collectionCategoryID}
                                            onChange={(e) => handleCollectioCategoryChange(e.target)}>
                                            <MenuItem value="0">--Select Collection Category--</MenuItem>
                                            {generateDropDownMenu(collectionCatagory)}
                                        </Select>
                                        {errors["collectionCategoryID"] && <FormHelperText error>{errors["collectionCategoryID"]}</FormHelperText>}
                                    </div>
                                    <div className="col-md pt-1">
                                        <MultiSelect
                                            items={collectionType}
                                            getOptionLabel={getOptionLabel}
                                            getOptionDisabled={getOptionDisabled}
                                            selectedValues={selectedOptions}
                                            label="Collection Types *"
                                            placeholder="Collection Types"
                                            selectAllLabel="Select all"
                                            isDisabled={(edit && data) ? true : false}
                                            onToggleOption={handleToggleOption}
                                            onClearOptions={handleClearOptions}
                                            onSelectAll={handleSelectAll}
                                        />
                                        {errors["collectionTypeID"] && <FormHelperText error>{errors["collectionTypeID"]}</FormHelperText>}
                                    </div>
                                </div>

                                {(edit && data) ? null :
                                    <div>
                                        <label>Active</label>
                                        <div className="form-group row">
                                            <div className="col-md ">
                                                <input
                                                    id="isActive"
                                                    switch="none"
                                                    className="mr-2"
                                                    type="checkbox"
                                                    name="isActive"
                                                    onChange={(e) => handleChange(e)}
                                                    checked={collectioncategoryTypeMapping.isActive}
                                                />
                                                <label htmlFor="isActive" data-on-label="Yes"
                                                    data-off-label="No"></label>
                                            </div>
                                        </div>
                                        <label>Is Default</label>
                                        <div className="form-group row">
                                            <div className="col-md ">
                                                <input
                                                    id="isDefault"
                                                    switch="none"
                                                    className="mr-2"
                                                    type="checkbox"
                                                    name="isDefault"
                                                    onChange={(e) => handleIsDefaultChange(e)}
                                                    checked={collectioncategoryTypeMapping.isDefault}
                                                />
                                                <label htmlFor="isDefault" data-on-label="Yes"
                                                    data-off-label="No"></label>
                                                {errors["isDefault"] && <FormHelperText error>{errors["isDefault"]}</FormHelperText>}
                                            </div>
                                        </div>
                                    </div>}

                                <div className="card-footer">
                                    <input
                                        type="submit"
                                        className="btn btn-primary"
                                        value={buttonText}
                                    />
                                    <input
                                        hidden={(edit && data) ? true : false}
                                        type="button"
                                        className="btn btn-warning pull-right"
                                        value="Clear"
                                        onClick={onCancelClick}
                                    />
                                </div>

                            </form>

                        </div>
                    </div>
                </div>
            </div>
            <MessageModal
                hidden={messageModel.hidden}
                messageType={messageModel.type}
                messageDescription={messageModel.disciption}
                clicked={modalDismissHandler}
            />
        </Fragment>
    );
}